import { ResponsiveContainer, AreaChart, Area, LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ComposedChart } from "recharts";
import { Box, Heading } from "@chakra-ui/react";

// Mock data for vaccine bookings and sales over the past 12 months (Apr 2024 - Mar 2025)
const data = [
  { month: "เม.ย. 67", Booking: 1200, Sales: 900 },
  { month: "เม.ย. 67", Booking: 1300, Sales: 1000 },
  { month: "มิ.ย. 67", Booking: 1400, Sales: 1100 },
  { month: "ก.ค. 67", Booking: 1500, Sales: 1200 },
  { month: "ส.ค. 67", Booking: 1600, Sales: 1300 },
  { month: "ก.ย. 67", Booking: 1700, Sales: 1400 },
  { month: "ต.ค. 67", Booking: 1280, Sales: 1500 },
  { month: "พ.ย. 67", Booking: 1500, Sales: 1600 },
  { month: "ธ.ค. 67", Booking: 1650, Sales: 1700 },
  { month: "ม.ค. 68", Booking: 1850, Sales: 1650 },
  { month: "ก.พ. 68", Booking: 1750, Sales: 1600 },
  { month: "มี.ค. 68", Booking: 1650, Sales: 1550 },
];

// Colors for each data series
const COLORS = {
  booking: "#5e87f5", // Blue for bookings
  sales: "#fb6095", // Red for sales
};

export function BookingAndSalesChart() {
  return (
    <Box w="100%" m={5}>
      <Heading size="md" mb={4}>ยอดจองและยอดจำหน่ายวัคซีนย้อนหลัง 12 เดือน</Heading>
      <ResponsiveContainer width="90%" height={300}>
        <ComposedChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Legend />

          {/* Area Chart - Booking Volume */}
          <Area type="monotone" dataKey="Booking" fill={COLORS.booking} stroke={COLORS.booking} name="ยอดจอง" />

          {/* Line Chart - Sales Volume */}
          <Area type="monotone" dataKey="Sales" fill={COLORS.sales} stroke={COLORS.sales} name="ยอดจำหน่าย" />
        </ComposedChart>
      </ResponsiveContainer>
    </Box>
  );
}